import translator from '@/locales';

export default function price(
  message = translator.t('PRICE_VALIDATION_ERROR'),
) {
  return {
    type: 'number',
    validator(rule, value, cb) {
      if (value <= 0) {
        return cb(new Error(message));
      }
      return cb();
    },
    message,
    trigger: 'blur',
  };
}
